import './CarouselArrow.scss'

import React, { useRef, useEffect, FC } from 'react'
import classNames from 'classnames'
import { isUndefined } from 'lodash'

import { safeGet } from '../utils/misc'

interface Props {
  direction: 'prev' | 'next'
  onClick?: any
  currentSlide?: number
  slideCount?: number
}

export const isDisable = (
  direction: 'prev' | 'next',
  currentSlide: number | undefined,
  diff: number,
  slideCount: number | undefined
) => {
  if (direction === 'prev') {
    if (currentSlide === 0) {
      return true
    }

    return false
  }

  if (!(currentSlide && slideCount)) {
    return false
  }

  return !!(currentSlide + diff >= slideCount)
}

const CarouselArrow: FC<Props> = ({ direction, onClick, currentSlide, slideCount }) => {
  const prevSlide = useRef(0)
  const diff = useRef(0)

  useEffect(() => {
    if (!(currentSlide && !isUndefined(prevSlide))) {
      return
    }
    diff.current = currentSlide - safeGet(() => prevSlide.current, 0)
    prevSlide.current = currentSlide
  }, [currentSlide])

  return (
    <button
      id={`CarouselMove${direction}`}
      className={classNames('CarouselArrow', `CarouselArrow--${direction}`, {
        'CarouselArrow--disable': isDisable(direction, currentSlide, diff.current, slideCount),
      })}
      onClick={onClick}
    >
      {direction}
    </button>
  )
}

export default CarouselArrow
